import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import {
  getFTTBFirewallLevel, getFTTBFirewallLevelItems,
  getFTTBFirewallNewLevel, getFTTBIsFirewallFormVisible,
} from 'pages/Internet/store/selectors/firewallSelectors';
import { setNewFirewallLevel, onUpdateFirewallForm } from 'pages/Internet/store/actions/firewallActions';
import { FirewallForm } from '../../components';

export const FirewallFormConnected = compose(
  connect(
    (state) => ({
      isVisible: getFTTBIsFirewallFormVisible(state),
      level: getFTTBFirewallNewLevel(state) ?? getFTTBFirewallLevel(state),
      levelItems: getFTTBFirewallLevelItems(state),
      shouldRender: !!getFTTBIsFirewallFormVisible(state) && !!getFTTBFirewallLevelItems(state).length,
    }),
    {
      onSave: onUpdateFirewallForm,
      setNewLevel: setNewFirewallLevel,
    },
  ), withRenderFlag,
)(FirewallForm);
